import React from 'react';
import styled from 'styled-components';
import Toggle from './Toggle';
import mediaQueries from './mediaQueries';
import FeedbackForm from './FeedbackForm';

const HeadContainer = styled.header`
    background-color: #dee6ed;
`;
const HeadContent = styled.header`
    height: 390px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 25px;
    @media ${mediaQueries.laptop} {
        height: 430px;
    }
`;

const Title = styled.h1`
    font-size: 32px;
    font-weight: 800;
    margin-bottom: 10px;
    text-align: center;

    @media ${mediaQueries.laptop} {
        font-size: 40px;
    }
`;

const Subtitle = styled.p`
    text-align: center;
    font-size: 16px;
`;

const ToggleContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 30px 0;
`;

const Menu = styled.div`
    position: absolute;
    top: 30px;
    right: 30px;
`;

interface Props {
    onToggle: (event: any) => void;
    showAdvancedSettings: boolean;
}

export const Header: React.FC<Props> = ({ showAdvancedSettings, onToggle }: Props) => {
    return (
        <HeadContainer>
            <Menu>
                <FeedbackForm />
            </Menu>

            <HeadContent>
                <Title>Stacking calculator</Title>
                <Subtitle>Find out what you could earn by locking up your Stacks Token</Subtitle>
                <ToggleContainer>
                    <Toggle
                        checked={showAdvancedSettings}
                        onToggle={(evt) => {
                            onToggle(evt);
                        }}
                    />
                </ToggleContainer>
            </HeadContent>
        </HeadContainer>
    );
};

export default Header;
